import React, { useMemo } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Header from "../../../../containers/Header";
import MainSection from "../../../../containers/MainSection";
import ErrorBoundary from "../../../ErrorBoundary";
import Modal from "../../../Modal";
import Menu from "../../Menu";
import ShopTitle from "../../Title";
import Overlay from "../../../Overlay";
import ShopAppPanel from "./ShopAppPanel";
import ShopModal from "./ShopAppModal";
import {
  useIdentity,
  useShopAppData,
  useUserpilotShopTracking,
} from "../../../../hooks";

interface ShopAppProps {
  panel?: string;
  modal?: string;
  params: Record<string, any>;
  location: any;
}

export default function ShopApp({
  panel,
  modal,
  params,
  location,
}: ShopAppProps) {
  const shopNumber = params?.shop_number;
  const identity = useIdentity();
  const { popups, shop, order, isAvalaraShop } = useShopAppData(shopNumber);
  useUserpilotShopTracking({ identity, location });

  const menu = useMemo(
    () => <Menu shop={shop} identity={identity} />,
    [shop, identity],
  );

  if (!shop) return null;

  if (modal) {
    const modalNode = (
      <ShopModal
        modal={modal}
        params={params}
        location={location}
        isAvalaraShop={isAvalaraShop}
        shop={shop}
        order={order}
      />
    );

    return (
      <DndProvider backend={HTML5Backend}>
        <ErrorBoundary>
          <div>
            <Modal
              modal={modalNode}
              order={order}
              popups={popups}
              project={shop}
            />
            <Overlay popups={popups} />
          </div>
        </ErrorBoundary>
      </DndProvider>
    );
  }

  return (
    <DndProvider backend={HTML5Backend}>
      <ErrorBoundary>
        <Header>
          <ShopTitle shop={shop} />
        </Header>
        <MainSection popups={panel !== "storefront" ? popups : []} menu={menu}>
          <ShopAppPanel
            panel={panel}
            shop={shop}
            order={order}
            popups={popups}
          />
        </MainSection>
        {panel !== "storefront" && <Overlay popups={popups} />}
      </ErrorBoundary>
    </DndProvider>
  );
}
